import {CenteredH2Section} from "@commons/uinew/domaincomponent/text";
import {CustomFormattedMessage} from "@commons/infra/component/CustomFormattedMessage";
import {createBreakpoints} from "@commons/uinew/component/swiper";
import {DifferentBackgroundSectionV2} from "@commons/uinew/section/DifferentBackgroundSection";
import React from "react";
import {PublicationsSwiperSection} from "@commons/uinew/domainsection/swipers/PublicationsSwiperSection";

export let StoryblokPublicationsSwiperSection = ({blok}) => {
    return <DifferentBackgroundSectionV2>
        <CenteredH2Section>
            <CustomFormattedMessage id={"pages.home.partners.title"}/>
        </CenteredH2Section>

        <PublicationsSwiperSection
            breakpoints={createBreakpoints(1, 2, 3)}
            items={blok.Items.map(item => ({
                src: item.Link.url,
                imgSrc: item.Image.filename,
                imgAlt: item.ImageAlt,
            }))}/>
    </DifferentBackgroundSectionV2>
}